import { render, staticRenderFns } from "./MultiSelect.vue?vue&type=template&id=38a488fa&scoped=true&"
import script from "./MultiSelect.vue?vue&type=script&lang=ts&"
export * from "./MultiSelect.vue?vue&type=script&lang=ts&"
import style0 from "./MultiSelect.vue?vue&type=style&index=0&id=38a488fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a488fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VCombobox,VDivider,VIcon,VRow})
